import React, { useEffect, useRef, useState } from 'react';
import { NavBar, Card, Button, Space, Dialog, Toast } from 'antd-mobile';
import { useLocation, useNavigate } from 'react-router-dom';
import '../styles/BorrowDetailPage.css';
import { applyReturn as apply4Return, confirmReturn } from '../componet/service';
import { Html5Qrcode } from 'html5-qrcode';

const BorrowDetailPage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { record } = location.state || {};
    const [scannerVisible, setScannerVisible] = useState(false);
    const scannerRef = useRef(null);

    useEffect(() => {
        return () => {
            if (scannerRef.current) {
                scannerRef.current.clear();
            }
        };
    }, []);
    // 初始化扫码器
    const initScanner = () => {
        const scannerContainer = document.getElementById('scanner-container');
        if (!scannerContainer) return;

        if (scannerRef.current) {
            scannerRef.current.clear();
        }
        const html5QrCode = new Html5Qrcode("scanner-container");
        scannerRef.current = html5QrCode;
        html5QrCode.start(
            { facingMode: "environment" },
            {
                fps: 10,
                qrbox: { width: 250, height: 250 },
            },
            (decodedText) => {
                // 扫码成功后的回调
                html5QrCode.stop().then(async () => {
                    setScannerVisible(false);
                    // 设置资产编号并触发数据加载
                    //TODO: 处理归还
                    //form.setFieldsValue({ assetNo: decodedText });
                    if (decodedText === record.assetNo) {
                        const res = await confirmReturn(decodedText);
                        if (res.code === 0) {
                            Toast.show({
                                icon: 'success',
                                content: '设备归还成功',
                                position: 'bottom',
                            });
                            navigate(-1);
                        } else {
                            Toast.show({
                                icon: 'fail',
                                content: res.msg,
                                position: 'bottom',
                            });
                        }
                    } else {
                        Toast.show({
                            icon: 'fail',
                            content: '设备编号不匹配',
                            position: 'bottom',
                        });
                    }

                });
            },
            (errorMessage) => {
                // 保持静默，不处理错误
                console.log(errorMessage);
            }
        ).catch(err => {
            Toast.show({
                content: '无法启动相机',
                position: 'bottom',
            });
            setScannerVisible(false);
        });
    };

    // 关闭扫码器
    const closeScanner = () => {
        if (scannerRef.current) {
            scannerRef.current.stop().then(() => {
                setScannerVisible(false);
            }).catch(err => {
                setScannerVisible(false);
            });
        } else {
            setScannerVisible(false);
        }
    };

    if (!record) {
        return (
            <div className="borrow-detail-container">
                <NavBar back="返回" onBack={() => navigate(-1)}>
                    记录详情
                </NavBar>
                <div className="error-message">记录不存在或已被删除</div>
            </div>
        );
    }

    // 申请归还
    const applyReturn = async () => {
        const result = await Dialog.confirm({
            content: '确认申请归还该设备吗？',
        });

        if (result) {
            // 这里替换为实际的API调用
            const res = await apply4Return(record.id);
            if (res.code === 0) {
                Toast.show({
                    icon: 'success',
                    content: '已申请，请等待审核',
                });
                navigate(-1);
            } else {
                Toast.show({
                    icon: 'fail',
                    content: '申请失败',
                });
            }

        }
    };

    const handleReturn = async () => {
        console.log('扫码功能触发');
        setScannerVisible(true);
        setTimeout(() => {
            initScanner();
        }, 100);
    }

    // 申请转移
    const applyTransfer = async () => {
        navigate('/transfer-apply', { state: { record } });
    };

    return (
        <>
            <div className="borrow-detail-container">
                <NavBar back="返回" onBack={() => navigate(-1)}>
                    借出记录详情
                </NavBar>

                <div className="detail-content">
                    <Card className="detail-card">
                        <div className="detail-header">
                            <div className="device-title">{record.name}</div>
                            <div className="device-status">{record.borrowStatus}</div>
                        </div>

                        <div className="detail-info">
                            <div className="info-item">
                                <span className="info-label">资产编号</span>
                                <span className="info-value">{record.assetNo}</span>
                            </div>
                            <div className="info-item">
                                <span className="info-label">设备类型</span>
                                <span className="info-value">{record.typeName}</span>
                            </div>
                            <div className="info-item">
                                <span className="info-label">出借人</span>
                                <span className="info-value">{record.borrower}</span>
                            </div>
                            <div className="info-item">
                                <span className="info-label">关系人</span>
                                <span className="info-value">{record.relatedUser}</span>
                            </div>
                            <div className="info-item">
                                <span className="info-label">出借时间</span>
                                <span className="info-value">{record.borrowTime}</span>
                            </div>
                            {
                                (record.borrowStatus === '申请转移' || record.borrowStatus === '已转移') &&
                                <>
                                    <div className="info-item">
                                        <span className="info-label">转移人员</span>
                                        <span className="info-value">{record.targetBorrower}</span>
                                    </div>
                                    <div className="info-item">
                                        <span className="info-label">转移关系人</span>
                                        <span className="info-value">{record.targetRelatedUser}</span>
                                    </div>
                                </>
                            }
                            {record.returnTime && (
                                <div className="info-item">
                                    <span className="info-label">归还时间</span>
                                    <span className="info-value">{record.returnTime}</span>
                                </div>
                            )}
                        </div>

                        {record.borrowStatus === '外借中' && (
                            <div className="action-buttons">
                                <Space direction="vertical" block>
                                    <Button
                                        block
                                        color="primary"
                                        onClick={applyReturn}
                                    >
                                        申请归还
                                    </Button>
                                    <Button
                                        block
                                        onClick={applyTransfer}
                                    >
                                        申请转移
                                    </Button>
                                </Space>
                            </div>
                        )}
                        {record.borrowStatus === '批准归还' && (
                            <div className="action-buttons">
                                <Space direction="vertical" block>
                                    <Button
                                        block
                                        color="primary"
                                        onClick={handleReturn}
                                    >
                                        设备归还
                                    </Button>

                                </Space>
                            </div>
                        )}
                    </Card>
                </div>
            </div>
            {scannerVisible && (
                <div className="scanner-overlay">
                    <div className="scanner-header">
                        <Button onClick={closeScanner} className="close-button">关闭</Button>
                    </div>
                    <div id="scanner-container" className="scanner-container"></div>
                    <div className="scanner-hint">
                        <p>请将二维码对准扫描框</p>
                    </div>
                </div>
            )}
        </>

    );
};

export default BorrowDetailPage;